"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVSClientProvider = exports.DVSClientContext = void 0;
var React = __importStar(require("react"));
var core_1 = __importDefault(require("../core"));
exports.DVSClientContext = React.createContext({
    state: 'empty',
    client: null,
});
var DVSClientProvider = function (props) {
    var _a = props.state, state = _a === void 0 ? 'empty' : _a, _b = props.client, client = _b === void 0 ? core_1.default : _b;
    var _c = React.useState(state), clientState = _c[0], setState = _c[1];
    client.onEvaluateStart(function () { return setState('loading'); });
    client.onEvaluateEnd(function () { return setState('ready'); });
    return (React.createElement(exports.DVSClientContext.Provider, { value: { client: client, state: clientState } }, props.children));
};
exports.DVSClientProvider = DVSClientProvider;
//# sourceMappingURL=context.js.map